import {Component} from 'preact';
import StringWrapper from "../../util/wrapper/StringWrapper";
import {formatPrice, getPickupLocationShippingRate} from "../../util/CurrencyUtils";
import {formatDistance} from "../../util/ConversionUtils";
import {getCurrentTranslation} from "../../../i18n/I18nResolver";

export default class LabelPriceDistanceAsideForm extends Component {

    constructor(props) {
        super(props);
    }

    getPrice = () => {
        const {config, pickupLocation, priceId} = this.props;

        const rate = getPickupLocationShippingRate(pickupLocation);

        const price = formatPrice(rate, config, "point__cost");

        return priceId ? <div id={priceId}>{price}</div> : price;
    };

    render() {
        const {pickupLocation, distanceId} = this.props;

        const distance = formatDistance(pickupLocation.distance);
        const distanceLabel = getCurrentTranslation().common.distance;
        const ariaLabelWithDistance = `${distanceLabel} ${distance}`;

        return (
            <section className="point__aside">
                {this.getPrice()}

                {
                    distance &&
                    <StringWrapper content={distance}
                                   additionalClassName="point__distance"
                                   htmlId={distanceId}
                                   ariaLabel={ariaLabelWithDistance}/>
                }
            </section>
        );
    }
}